import PropTypes from 'prop-types'
import { Select, Body2, Caption } from '../../../../cdl-react-components/components'

const coordinateRange = (props) => {
    const start = props.name + 'Start'
    const end = props.name + 'End'

    return (
        <tr className="search__location__coordinate_range">
            <td><Body2>{props.title}</Body2></td>
            <td>
                <Select 
                    label=""
                    placeholder="Start"
                    options={props.options}
                    value={props.data[start]}
                    onChange={props.handleChange(start)} />
            </td>
            <td><Caption>To</Caption></td>
            <td>
                <Select
                    label=""
                    placeholder="End"
                    options={props.options}
                    value={props.data[end]}
                    onChange={props.handleChange(end)} />
            </td>
        </tr>
    )
}

coordinateRange.propTypes = {
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
    data: PropTypes.object.isRequired,
    handleChange: PropTypes.func.isRequired
}

export default coordinateRange